<div
  id="router-outlet"
  [@fadeAnimation]="o.isActivated ? o.activatedRoute : ''"
>
  <router-outlet #o="outlet"></router-outlet>
</div>
